import React from "react";
import lodashGet from "lodash.get";

export const DTM_EVENTS_DOM_ELEMENT = "dtmEventsDomElement";

export default React.createContext({
  dtmIsReady: undefined,
  ddlIsDirty: undefined,
  digitalData: {}
});

export const dispatchAnalyticsEvent = (_document, name, data) => {
  if (lodashGet(global, "CustomEvent")) {
    // eslint-disable-next-line no-undef
    const customEvent = new CustomEvent(name, {
      bubbles: true,
      detail: data
    });
    const domElement = _document.getElementById(
      DTM_EVENTS_DOM_ELEMENT.toString()
    );
    if (domElement !== null) {
      _document
        .getElementById(DTM_EVENTS_DOM_ELEMENT.toString())
        .dispatchEvent(customEvent);
    }
  }
};
